<template>
  <div class="page">
    <MyHeader></MyHeader>

    <div class="content">
      <div class="section_intro flex-inline">
        <div class="flex-column-left">
          <div class="fs-50 fw-bold color-white">{{ $t('hubValid') }}</div>
          <div class="fs-24 color-white mt-28">{{ $t('hubValidTip') }}</div>
        </div>
        <div class="img-anth hidden-md-and-down"></div>
      </div>

      <div class="form-container flex-center">
        <div class="tips flex-column" v-if="errMessage">
          <i class="icon ri-checkbox-circle-fill color-success" v-show="success"></i>
          <i class="icon ri-error-warning-fill color-warning" v-show="!success"></i>
          <div class="tip-content">
            No.213 HUB HUB is not sure from the official sales channel
          </div>
        </div>

        <div class="form flex-column-left">
          <div class="from-item">
            <div class="label text-left">{{ $t('validFormAccount') }}</div>
            <input type="text" class="input width-400" :placeholder="$t('validFormAccountTip')">
          </div>
          <div class="from-item mt-30">
            <div class="label text-left">{{ $t('validFormNumber') }}</div>
            <input type="text" class="input width-400" :placeholder="$t('validFormNumberTip')">
          </div>
          <div class="btn-auth flex-center mt-40" @click="validate">{{ $t('validate') }}</div>
        </div>

      </div>
    </div>

    <MyFooter></MyFooter>
  </div>
</template>

<script>
  import MyHeader from '@/views/components/Header.vue'
  import MyFooter from '@/views/components/Footer.vue'

  export default {
    name: 'auth',
    components: { MyHeader, MyFooter },
    data () {
      return {
        errMessage: '',
        success: false
      }
    },
    methods: {
      validate () {
        this.$notify.info({
          title: 'message',
          message: 'Will be open soon!'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/common.scss';

  .section_intro {
    background-color: #00EBB3;
    padding: 6rem 20rem;

    .img-anth {
      width: 25.6rem;
      height: 20rem;
      background: url("../../static/auth.png") center no-repeat;
    }
  }

  .form-container {
    padding: 20rem 0;

    .tips {
      margin-right: 14.6%;;
      .icon {
        font-size: 12rem;
      }
      .tip-content {
        max-width: 36rem;
        margin-top: 2.5rem;
        line-height: 4rem;
        font-size: 2.3rem;
        color: #222222;
      }
    }
    .form {
      padding: 6rem 6rem 3.2rem;
      border-radius: 0.4rem;
      @include box-shadow;
    }

    .from-item {
      .label {
        color: #222222;
        font-size: 2rem;
      }

      .input {
        margin-top: 1rem;
        padding-bottom: 1rem;
        outline: none;
        border: none;
        border-bottom: 0.1rem solid #F5F5F5;
        font-size: 1.4rem;
        transition: border .3s ease;

        &::placeholder {
          font-size: 1.4rem;
          color: #888888;
        }

        &:focus {
          border-color: $color;
        }
      }
    }
    .btn-auth {
      width: 23.8rem;
      height: 6.8rem;
      align-self: flex-end;
      font-size: 2.3rem;
      color: #FFFFFF;
      background-color: #222222;
      border-radius: 0.4rem;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        color: $color;
        @include box-shadow;
      }
    }
  }

  /* 其他 */
  .width-400 {
    width: 40rem;
  }
  .mt-28 {
    margin-top: 2.8rem;
  }

  @media screen and (max-width: 768px) {

    .section_intro {
      padding: 3rem 1rem;

      .fs-50 {
        width: 100%;
        font-size: 3rem;
        text-align: center;
      }

      .fs-24 {
        font-size: 2rem;
      }
    }

    .form-container {
      padding: 10rem 0;

      .form {
        width: 80%;
        padding-left: 2rem;
        padding-right: 2rem;

        .from-item,
        .from-item .width-400 {
          width: 100%;
        }
      }
    }
  }
</style>
